import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const MODAL_STORAGE_KEY = 'exclusive-modal-shown';
const MODAL_EXPIRY_HOURS = 24; // La modale peut réapparaître après 24h

// Pages où la modale doit s'afficher
const MODAL_PAGES = [
  '/',
  '/entreprise/recrutement',
  '/entreprise/campagnes',
  '/entreprise/externalisation',
  '/entreprise/ia',
  '/entreprise/talent-rh-ai',
  '/entreprise/cabinet-recrutement-marseille'
];

export function useExclusiveModal() {
  const [shouldShowModal, setShouldShowModal] = useState(false);
  const location = useLocation();

  useEffect(() => {
    // Vérifier si on est sur une page éligible
    const isEligiblePage = MODAL_PAGES.includes(location.pathname);
    
    if (!isEligiblePage) {
      setShouldShowModal(false);
      return;
    }

    // Vérifier si la modale a déjà été montrée récemment
    const modalData = localStorage.getItem(MODAL_STORAGE_KEY);
    
    if (modalData) {
      try {
        const { timestamp } = JSON.parse(modalData);
        const now = Date.now();
        const hoursSinceShown = (now - timestamp) / (1000 * 60 * 60);
        
        // Si moins de 24h se sont écoulées, ne pas montrer la modale
        if (hoursSinceShown < MODAL_EXPIRY_HOURS) {
          setShouldShowModal(false);
          return;
        }
      } catch (error) {
        // Si erreur de parsing, on supprime la donnée corrompue
        localStorage.removeItem(MODAL_STORAGE_KEY);
      }
    }

    // Délai avant d'afficher la modale (3 secondes après le chargement)
    const timer = setTimeout(() => {
      setShouldShowModal(true);
    }, 3000);

    return () => clearTimeout(timer);
  }, [location.pathname]);

  const markModalAsShown = () => {
    const modalData = {
      timestamp: Date.now(),
      page: location.pathname
    };
    localStorage.setItem(MODAL_STORAGE_KEY, JSON.stringify(modalData));
    setShouldShowModal(false);
  };

  const closeModal = () => {
    markModalAsShown();
  };

  return {
    shouldShowModal,
    closeModal,
    markModalAsShown
  };
}